import * as React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons'
import {H3, H4} from '@frontrow/console/src/components/typography'

import {Link} from '@frontrow/console/src/components/ui/link'
import {type ItemT} from '@frontrow/console/src/entities/models/item'

import AvatarWithItem from '@frontrow/console/src/components/pages/piggy-store-page/avatar-with-item'
import {
  DEFAULT_PIGGY_STORE_GRADE,
  MATURE_PIGGY_STORE_GRADE
} from '@frontrow/console/src/components/pages/piggy-store-page/piggy-store'
import {Routes} from '@frontrow/console/src/routers/routes'

type Props = {
  item: ItemT
}

export default function ItemCard(props: Props): React.ReactElement {
  const {id, name, category, price} = props.item
  const avatarToUse = 'piggy'

  return (
    <div className="p-4 bg-white border border-chrome rounded text-center m-1">
      <AvatarWithItem
        avatarName={avatarToUse}
        itemName={name}
        itemCategory={category}
        grade={DEFAULT_PIGGY_STORE_GRADE}
        addClass="inline-block"
      />
      <AvatarWithItem
        avatarName={avatarToUse}
        itemName={name}
        itemCategory={category}
        grade={MATURE_PIGGY_STORE_GRADE}
        addClass="inline-block"
      />
      <H3>{name}</H3>
      <span>{price} coins</span>
      <H4>{category}</H4>
      <Link title="Edit Item" href={Routes.items.itemEdit(id)} reactRouter>
        <FontAwesomeIcon icon={faPencilAlt} />
      </Link>
    </div>
  )
}
